/// <reference path="../../../teva/slideorfade/slideorfade.ts" />
/// <reference path="../../../teva/positioning/positioning.ts" />
/// <reference path="../smooth/smooth.ts" />
/// <reference path="../navigation/navigation.ts" />
/// <reference path="../notifications/notifications.ts" />

namespace OfficeGuy {
    export class Forms {
        static InitCSRF() {
            var isAbsoluteURI = new RegExp('^(?:[a-z]+:)?//', 'i'); //http://stackoverflow.com/questions/10687099/how-to-test-if-a-url-string-is-absolute-or-relative

            $.ajaxSetup({
                error: OfficeGuy.Common.AjaxError,
                beforeSend: function (xhr) {
                    (<any>xhr).requestURL = this.url;
                    if ((this.url.indexOf(window.location.origin) == 0 || !isAbsoluteURI.test(this.url)) && this.type != "GET") {
                        //only add header to relative URLs
                        xhr.setRequestHeader("X-XSRF-Token", Common.AntiForgeryToken);
                        if (Common.LoggedCompanyID != null)
                            xhr.setRequestHeader("X-OG-CompanyID", Common.LoggedCompanyID.toString());
                    }
                }
            });
        }

        static DisableForm($Form): boolean {
            //Form.data("validator").settings.success = false;
            if ($Form.data("submitted") == "1")
                return false;
            //if ($Form.closest(".modal").length == 0 && Modals.VisibleModals.length > 0 && $(Modals.VisibleModals[0]).find("form").length > 0)
            //return false;
            //if (Form.closest(".modal").length != 0 && Modals.VisibleModals[Modals.VisibleModals.length - 1] != Form.closest(".modal")[0])
            //  return false;

            if (!$Form.valid()) {
                $(".field-validation-error").trigger("focus");
                Teva.Positioning.ScrollToElement($(".field-validation-error"));
                return false;
            }
            if ($Form.attr("onpresubmit") !== undefined) {
                if ($Form.attr("onpresubmit") != "" && !Function($Form.attr("onpresubmit"))())
                    return false;
            }
            if ($Form.attr("target") == null) {
                //Navigation.Loading_Show();
                $("input[type=submit]", $Form).attr("disabled", "disabled");
                $Form.data("submitted", "1");
            }

            return true;
        }
        static EnableForm($Form): boolean {
            $("input[type=submit]", $Form).attr("disabled", null);
            $Form.data("submitted", null);
            return true;
        }

        static ConvertFormToAjax($Form, $ContainerToRefresh = null, PreRenderEvent = null, IsModal = false): void {
            $Form.off("submit.disableform");
            $Form.off("submit.convertformtoajax");
            $Form.on("submit.convertformtoajax", function () {
                var Data;
                if (typeof (FormData) !== "undefined" && FormData && $Form.attr("method") != "get") {
                    Data = new FormData($Form[0]);
                    if (Data.delete !== undefined) {
                        $("input[type=file]", $Form).each(function () {
                            var $this = $(this);
                            var Files = $this.prop('files');
                            var InputName = $this.attr('name');
                            if (Files != undefined && Files.length <= 0) {
                                var InputValues = $("input, textarea").filter(function () {
                                    var $this = $(this);
                                    return $this.attr("name") == InputName && $this.val() != null && $this.val() != "";
                                });
                                if (InputValues.length == 0)
                                    Data.delete(InputName);
                            }
                        });
                    }
                }
                else
                    Data = $Form.serialize();
                if (Forms.DisableForm($Form)) {
                    if ($Form.hasClass("preventajax") || $Form.attr("target"))
                        return true;
                    Navigation.Loading_Show();
                    $.ajax({
                        type: $Form.attr("method"),
                        data: Data,
                        url: $Form.attr("action"),
                        headers: IsModal ? { "x-modal": "1" } : null,
                        contentType: false,
                        processData: false,
                        error: function (Request, Status, Exception) {
                            OfficeGuy.Common.AjaxError(Request, Status, Exception);
                            Navigation.Loading_Hide();
                            Forms.EnableForm($Form);
                        },
                        success: function (Response) {
                            if (PreRenderEvent != null) {
                                if (PreRenderEvent(Response)) {
                                    Navigation.Loading_Hide();
                                    return;
                                }
                            }
                            if (typeof (Response) != "string") {
                                if (Response.Notifications != null) {
                                    setTimeout(function () {
                                        Notifications.Show(Response.Notifications);
                                    }, 200);
                                }
                                if (Response.ErrorMessage != null) {
                                    setTimeout(function () {
                                        Modals.ShowMessageDialog(Response.ErrorTitle == null ? "הודעת מערכת" : Response.ErrorTitle, Response.ErrorMessage, Response.ErrorButton);
                                        Forms.EnableForm($Form);
                                        Navigation.Loading_Hide();
                                    }, 200);
                                    return false;
                                }
                                if (Response.RedirectURL !== undefined) {
                                    var RefreshEntitiesList = Response.RefreshEntitiesList === true;
                                    var IsRefresh = Response.RedirectURL == ".";
                                    if (IsRefresh)
                                        Response.RedirectURL = window.location.href;

                                    if (IsModal && Response.CloseModal) {
                                        Modals.Hide($Form.closest(".modal"), false, true);
                                        Navigation.Loading_Hide();
                                    }
                                    else if (Response.FullRefresh) {
                                        window.location.href = Response.RedirectURL;
                                        Navigation.Loading_Hide();
                                    }
                                    else {
                                        if (IsModal) {
                                            Modals.HideAll(false, function () {
                                                if (IsRefresh)
                                                    Response.RedirectURL = window.location.href;
                                                if (RefreshEntitiesList && Forms.AllowRefreshEntitiesList())
                                                    Forms.RefreshEntitiesList();
                                                else
                                                    Navigation.Redirect(Response.RedirectURL, Response.AllowRedirectModal == false);
                                                Navigation.Loading_Hide();
                                            });
                                        }
                                        else {
                                            if (RefreshEntitiesList && Forms.AllowRefreshEntitiesList()) {
                                                Modals.HideAll();
                                                Forms.EnableForm($Form);
                                                Forms.RefreshEntitiesList();
                                            }
                                            else
                                                Navigation.Redirect(Response.RedirectURL, Response.AllowRedirectModal == false);
                                            Navigation.Loading_Hide();
                                        }
                                    }
                                    return false;
                                }
                                if (Response.Success) {
                                    if (Response.SuccessScript)
                                        eval(Response.SuccessScript);
                                    if ($Form.data("ConvertFormToAjaxEvent"))
                                        $Form.data("ConvertFormToAjaxEvent")(Response, $Form);
                                }
                                else
                                    Forms.EnableForm($Form);
                                Navigation.Loading_Hide();
                            }
                            else if ($ContainerToRefresh == null) {
                                OfficeGuy.Smooth.RequestedURL = window.location.href;
                                OfficeGuy.Smooth.StorePage(OfficeGuy.Smooth.ProcessData, window.location.href, Response, false, false, false);
                                OfficeGuy.Smooth.UpdateContentFromCache(window.location.href, false)
                                Navigation.Loading_Hide();
                                return false;
                            }
                            else {
                                Navigation.Loading_Hide();
                                $ContainerToRefresh.hide();
                                if ($ContainerToRefresh.hasClass("modal-content")) {
                                    var $CloseButton = $("> .close", $ContainerToRefresh);
                                    $ContainerToRefresh.html(Response);
                                    $ContainerToRefresh.append($CloseButton);
                                }
                                else
                                    $ContainerToRefresh.html(Response);

                                $ContainerToRefresh.fadeIn(500);
                                if ($ContainerToRefresh[0].tagName == "FORM") {
                                    $ContainerToRefresh.data("submitted", null);
                                    Forms.ConvertFormToAjax($ContainerToRefresh, null, null, IsModal);
                                }
                                else
                                    Forms.ConvertFormToAjax($("form", $ContainerToRefresh), $ContainerToRefresh, PreRenderEvent, IsModal);
                                Common.InitEditors($ContainerToRefresh);
                                //Common.PageLoad($ContainerToRefresh, null, null);
                                Teva.Navigation.FocusOnFirstField($ContainerToRefresh);
                                if (Modals.VisibleModals.length == 0)
                                    Teva.Positioning.ScrollToElement($(document.body));
                            }
                        },
                    });
                }
                return false;
            });
        }

        static AllowRefreshEntitiesList() {
            var $Form = $('form.crmform_entities');
            if ($Form.length == 0 || $Form.find(".entities-table-edit").length > 0)
                return false;

            return true;
        }
        static RefreshEntitiesList() {
            var $Form = $('form.crmform_entities');
            if ($Form.length == 0 || $Form.find(".entities-table-edit").length > 0)
                return false;

            $Form.find("input[name=SelectedCommand], input[name=SelectedEntities]").val("");
            Forms.SubmitForm($Form);
            return true;
        }

        static FormSubmit_Init() {
            $(document.body).on("click.og-submitform", ".og-submitform", function () {
                var $this = $(this);
                var FormSelector = $this.data("formselector");
                if (FormSelector)
                    Forms.SubmitForm(FormSelector);
                else
                    Forms.SubmitForm($this.closest("form"));
                return false;
            });
        }
        static SubmitFormSkipValidation(Selector: any = "form"): boolean {
            $(Selector).validate().settings.ignore = '*';
            return Forms.SubmitForm(Selector);
        }
        static SubmitForm(Selector: any = "form"): boolean {
            $(document).trigger("click.SelectBox");
            var $Form = $(Selector);
            var PreviousIgnore = $Form.validate().settings.ignore;
            if ($Form.hasClass("og-form-skipvalidation") || PreviousIgnore == '*' || $("form").find("input, select").length > 500)
                $Form.validate().settings.ignore = '*';
            else
                $Form.validate().settings.ignore = '.input-validation-warning';

            var Form = $Form[0];
            if (Form == null)
                return false;
            if (Form.onsubmit) {
                var Result = Form.onsubmit.call(Form);
                if (Result !== false)
                    $Form.trigger("submit");
            }
            else
                $Form.trigger("submit");
            $Form.validate().settings.ignore = PreviousIgnore;
            return false;
        }

        static ToggleDisableForm($Element: JQuery, Toggle: boolean, SlideAnimation: boolean = true) {
            if (!SlideAnimation || window.event == null || window.event.target == document) {
                $Element.toggle(Toggle);
                $Element.find("input, select").attr("disabled", Toggle ? null : "disabled");
                return;
            }

            if (Toggle) {
                $Element.stop(true, false);
                $Element.find("input, select").attr("disabled", Toggle ? null : "disabled");
                Teva.SlideOrFade.Show($Element, 400, function () {
                    $Element.find("input, select").attr("disabled", Toggle ? null : "disabled");
                    $Element.css("height", "auto");
                });
            }
            else {
                $Element.stop(true, false);
                Teva.SlideOrFade.Hide($Element, 400, function () {
                    $Element.find("input, select").attr("disabled", Toggle ? null : "disabled");
                });
            }
        }
        static ToggleSlide($Element: JQuery, Toggle: boolean, SlideAnimation: boolean = true) {
            if (!SlideAnimation || window.event == null || window.event.target == document) {
                $Element.toggle(Toggle);
                return;
            }

            if (Toggle) {
                $Element.stop(true, false);
                Teva.SlideOrFade.Show($Element, 400, function () {
                    $Element.css("height", "auto");
                });
            }
            else {
                $Element.stop(true, false);
                Teva.SlideOrFade.Hide($Element, 400);
            }
        }

        static NestedForm_Add(ContainerSelector, CounterSelector, Ticks, Content, Prepend, CounterTagName = null) {
            var $ContainerSelector = $(ContainerSelector);
            if (CounterTagName === undefined || CounterTagName == null || CounterTagName.length == 0)
                CounterTagName = "tr";
            var Index = $(">" + CounterTagName, CounterSelector).length;
            var Pattern = new RegExp(Ticks, "gi");
            Content = Content.replace(Pattern, Index);
            var $NewElement = $(Content);
            if (Prepend != null && Prepend != "undefined" && Prepend == true)
                $ContainerSelector.prepend($NewElement);
            else
                $ContainerSelector.append($NewElement);

            (<any>$.validator).unobtrusive.parseDynamicContent($NewElement);
            OfficeGuy.Common.InitEditors($NewElement);
            return $NewElement;
        }
        static NestedForm_Replace(ContainerSelector, Ticks, Content, Index) {
            var $ContainerSelector = $(ContainerSelector);
            $($(">tr", $ContainerSelector)[Index]).remove();
            var Pattern = new RegExp(Ticks, "gi");
            Content = Content.replace(Pattern, Index);
            var $NewElement = $(Content);
            if (Index == 0)
                $ContainerSelector.prepend($NewElement);
            else
                $($(">tr", $ContainerSelector)[Index - 1]).after($NewElement);

            (<any>$.validator).unobtrusive.parseDynamicContent($NewElement);

            return $NewElement;
        }
        static NestedForm_Remove(ContainerSelector, ContainerName, Index): void {
            var $ContainerSelector = $(ContainerSelector);

            var originalIndex = Index;

            $("input[name*='" + ContainerName + "[" + Index + "]'], textarea[name*='" + ContainerName + "[" + Index + "]'], select[name*='" + ContainerName + "[" + Index + "]']").remove();
            Index++;
            var $Next = $("input[name*='" + ContainerName + "[" + Index + "]'], textarea[name*='" + ContainerName + "[" + Index + "]'], select[name*='" + ContainerName + "[" + Index + "]']");
            while ($Next.length > 0) {
                $Next.each(function () {
                    var $this = $(this);
                    $this.attr("name", ContainerName + "[" + (Index - 1) + "]" + $this.attr("name").substring((ContainerName + "[" + Index + "]").length));
                });
                Index++;
                $Next = $("input[name*='" + ContainerName + "[" + Index + "]'], textarea[name*='" + ContainerName + "[" + Index + "]'], select[name*='" + ContainerName + "[" + Index + "]']");
            }

            var MaximumIndex = 0;
            if ($ContainerSelector != null)
                MaximumIndex = $(">tr", $ContainerSelector).length;

            var ValidationChanged = false;
            Index = originalIndex;
            var $Selector = $("span[data-valmsg-for*='" + ContainerName + "[" + Index + "]']");
            if ($Selector.length > 0)
                ValidationChanged = true;
            $Selector.remove();
            Index++;
            var $Next = $("span[data-valmsg-for*='" + ContainerName + "[" + Index + "]']");
            while ($Next.length > 0 || Index < MaximumIndex) {
                if ($Next.length > 0)
                    ValidationChanged = true;
                $Next.each(function () {
                    var $this = $(this);
                    $this.attr("data-valmsg-for", ContainerName + "[" + (Index - 1) + "]" + $this.attr("data-valmsg-for").substring((ContainerName + "[" + Index + "]").length));
                });
                Index++;
                $Next = $("span[data-valmsg-for*='" + ContainerName + "[" + Index + "]']");
            }
            if (ValidationChanged && $ContainerSelector != null) {
                $ContainerSelector.closest('form').removeData('validator').removeData('unobtrusiveValidation');
                (<any>$.validator).unobtrusive.parse($ContainerSelector.closest('form'));
            }
            Common.Tooltip_Hide();
        }

        static ParseDynamicContent_Init(): void {
            if ($.validator == null || (<any>$.validator).unobtrusive.parseDynamicContent != null)
                return;
            (<any>$.validator).unobtrusive.parseDynamicContent = function (selector) {
                //use the normal unobstrusive.parse method
                (<any>$.validator).unobtrusive.parse(selector);

                //get the relevant form
                var $Form = $(selector).first().closest('form');
                if ($Form.length == 0 && $("form").length == 1)
                    $Form = $("form");
                if ($Form.length == 0)
                    return;

                //get the collections of unobstrusive validators, and jquery validators
                //and compare the two
                var unobtrusiveValidation = $Form.data('unobtrusiveValidation');
                if (unobtrusiveValidation == null)
                    return;

                var validator = $Form.validate();

                $.each(unobtrusiveValidation.options.rules, function (elname: string, elrules) {
                    if (validator.settings.rules[elname] == undefined) {
                        var args: any = {};
                        $.extend(args, elrules);
                        args.messages = unobtrusiveValidation.options.messages[elname];
                        //edit:use quoted strings for the name selector
                        $("[name='" + elname + "']").rules("add", args);
                    } else {
                        $.each(elrules, function (rulename, data) {
                            if (validator.settings.rules[elname][rulename] == undefined) {
                                var args: any = {};
                                args[rulename] = data;
                                args.messages = unobtrusiveValidation.options.messages[elname][rulename];
                                //edit:use quoted strings for the name selector
                                $("[name='" + elname + "']").rules("add", args);
                            }
                        });
                    }
                });
            };
        }

        static PreventFormKeyPress(FormSelector) {
            $(FormSelector).on("keypress", function (Event) {
                if (Event.target.tagName == "TEXTAREA")
                    return true;
                return Event.key != "Enter";
            });
        }

        static DirtyPageLoad() {
            var $Form = $("form.preventdirty");
            $(window).off("beforeunload.preventdirty");
            if ($Form.length == 0)
                return;

            $Form
                .on("change.preventdirty", function (Event) {
                    if (window.event == null || window.event.type == "DOMContentLoaded" || window.event.type == "readystatechange" || window.event.type == "load")
                        return;

                    var Tag = (<Element>Event.target).tagName;
                    if (Tag == "INPUT" || Tag == "SELECT" || Tag == "TEXTAREA")
                        Forms.SetDirty($(this));
                })
                .on("submit.preventdirty", function () {
                    $(this)
                        .data("og-modified", false)
                        .off("change.preventdirty");
                });

            $(window).on("beforeunload.preventdirty", function (Event) {
                if (Forms.IsDirty($Form))
                    return (<any>Event).returnValue = OfficeGuy.Resources.GetString("CRM", "UnsavedWarning");
            });
        }
        static SetDirty($Form = null) {
            if ($Form == null)
                $Form = $("form.preventdirty");
            $Form.data("og-modified", true);
        }
        static ClearDirty($Form = null) {
            if ($Form == null)
                $Form = $("form.preventdirty");
            $Form.data("og-modified", false);
        }
        static ToggleDirty($Form, Dirty) {
            $Form.data("og-modified", Dirty);
        }
        static IsDirty($Form = null) {
            if ($Form == null)
                $Form = $("form.preventdirty");
            return $Form.data("og-modified") === true;
        }
        static DirtyNavigation(ConfirmEvent, $Form = null, IgnoreTimeout = false) {
            if ($Form == null)
                $Form = $("form.preventdirty");
            if ($Form.length == 0 || !Forms.IsDirty($Form)) {
                ConfirmEvent();
                return;
            }
            if (!IgnoreTimeout && $Form.data("og-preventdirtysavetimeout")) {
                var TimeoutPending = Number($Form.data("og-preventdirtysavetimeout"));
                var CheckFunction = function () {
                    if (TimeoutPending <= 0 || !Forms.IsDirty($Form))
                        Forms.DirtyNavigation(ConfirmEvent, $Form, true);
                    else {
                        TimeoutPending -= 100;
                        setTimeout(CheckFunction, 100);
                    }
                };
                setTimeout(CheckFunction, 100);
                return;
            }

            var $ContinueButton;
            var $Modal = Modals.Create({
                Simple: true,
                Title: OfficeGuy.Resources.GetString("CRM", "DiscardChangesHeader"),
                Body: OfficeGuy.Resources.GetString("CRM", "DiscardChangesContents"),
                Buttons: [
                    $(document.createElement('input'))
                        .addClass("og-button-ui-action og-button-color-grayunframed")
                        .attr("type", "button")
                        .val(OfficeGuy.Resources.GetString("CRM", "DiscardChangesExitWithoutSaving"))
                        .on("click", function () {
                            Forms.ClearDirty($Form);
                            ConfirmEvent();
                            Modals.Hide($Modal);
                            return false;
                        }),
                    $ContinueButton = $(document.createElement('input'))
                        .addClass("og-button-ui-action og-button-color-submit")
                        .attr("type", "button")
                        .val(OfficeGuy.Resources.GetString("CRM", "DiscardChangesContinueEditing"))
                        .on("click", function () {
                            Modals.Hide($Modal);
                            return false;
                        })
                ],
                ShownEvent: function () {
                    $ContinueButton.trigger("focus");
                }
            });
            return $Modal;
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Forms.ParseDynamicContent_Init();
    OfficeGuy.Forms.FormSubmit_Init();
    OfficeGuy.Forms.InitCSRF();
});
$(document).on("Teva.PageLoad", function () {
    OfficeGuy.Forms.DirtyPageLoad();
    $("form").each(function () {
        var $Form = $(this);
        var $Form = $(this);
        if ($Form.closest('.modal').length == 0) {
            var $ContainerToRefresh = $Form.closest(".sumit-lightbox-container");
            if ($ContainerToRefresh.length == 0)
                $ContainerToRefresh = null;
            OfficeGuy.Forms.ConvertFormToAjax($Form, $ContainerToRefresh);
        }
    });
});